import { css } from 'styled-components';
import { pxToRem, fontSize } from '@fil-react-mixins/styled';

import { SpinnerProps } from './Spinner';

const sizeMap = {
  default: 32,
  small: 20,
  medium: 40,
  large: 120,
};

export default css<SpinnerProps>`
  line-height: 0;

  /** Animations **/
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .fil-spinner {
    background-color: transparent;

    &__text {
      ${fontSize}
      padding: 0.5em 0;
      display: block;
    }

    &__overlay {
      background-color: ${(props) => props.theme.spinner.overlayColor};
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1007;
      height: 100%;
      width: 100%;
    }

    &__spins {
      position: relative;
      width: 1.5em;
      height: 1.5em;
      margin: 0 auto;
      display: block;
      font-size: ${({ size = 'default' }) =>
        // @ts-ignore
        pxToRem((sizeMap[size] || size) / 1.5)};

      .spin {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: 1.2s cubic-bezier(0.5, 0, 0.5, 1) 0s infinite normal none running spinner;
        border-width: 0.2em;
        border-style: solid;
        border-color: ${(props) => props.theme.color.loader.value} transparent transparent;

        &:nth-child(1) {
          animation-delay: -0.45s;
        }

        &:nth-child(2) {
          animation-delay: -0.3s;
        }

        &:nth-child(3) {
          animation-delay: -0.15s;
        }
      }
    }

    ${({ displayType }) =>
      displayType === 'fixed' &&
      css`
        position: fixed;
        left: 0;
        top: 50%;
        z-index: 1008;
        width: 100%;
        text-align: center;
        transform: translateY(-50%);

        .fil-spinner__text {
          font-size: ${pxToRem(32)};
        }
      `}

    ${({ displayType }) =>
      displayType === 'inline' &&
      css`
        display: inline-block;
      `}
  }
`;
